import { render, staticRenderFns } from "./TimeUpEnd.vue?vue&type=template&id=6c8e00fa&scoped=true&"
import script from "./TimeUpEnd.vue?vue&type=script&lang=js&"
export * from "./TimeUpEnd.vue?vue&type=script&lang=js&"
import style0 from "./TimeUpEnd.vue?vue&type=style&index=0&id=6c8e00fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8e00fa",
  null
  
)

export default component.exports